// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/callback","layout":false,"id":"1"},"2":{"path":"/user","layout":false,"id":"2"},"3":{"name":"login","path":"/user/login","parentId":"2","id":"3"},"4":{"path":"/user/access-denied","parentId":"2","id":"4"},"5":{"path":"/calendar","name":"myCalendars","icon":"calendar","parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"/calendar/settings","name":"calendarSettings","icon":"setting","parentId":"ant-design-pro-layout","id":"6"},"7":{"path":"/calendar-settings","redirect":"/calendar/settings","hideInMenu":true,"parentId":"ant-design-pro-layout","id":"7"},"8":{"path":"/","redirect":"/calendar","parentId":"ant-design-pro-layout","id":"8"},"9":{"path":"*","layout":false,"id":"9"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__callback" */'@/pages/callback.tsx')),
'2': React.lazy(() => import('./EmptyRoute')),
'3': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__user__access-denied__index" */'@/pages/user/access-denied/index.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__Schedule__Calendar__index" */'@/pages/Schedule/Calendar/index.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__Schedule__CalendarSettings__index" */'@/pages/Schedule/CalendarSettings/index.tsx')),
'7': React.lazy(() => import('./EmptyRoute')),
'8': React.lazy(() => import('./EmptyRoute')),
'9': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/app/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
